export default function(api: GlobalFetch) {
  return async function(values) {
    await api.fetch(
      `/api/v2/booking/name/id_integration/${values.id_integration}`,
      {
        method: 'POST',
        body: JSON.stringify(values),
      },
    )
  }
}
